import React from 'react';

import styles from './CouponsDetails.module.scss';

/**
 * "Description" panel — per the redesign this is just the heading + the
 * coupon's raw description text (the price/deal/new breakdown that used to
 * live here now shows up as the big red deal amount + chips in the hero
 * card instead).
 */
const CouponDescription = ({ data }) => {
  const { description } = data || {};

  return (
    <div>
      <h3 className={styles.infoCardTitle}>Description</h3>
      <p className={styles.infoCardText}>{description}</p>
    </div>
  );
};

export default CouponDescription;
